import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { addResizeCallback, removeResizeCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { TabBarPresentation } from './TabBarPresentation.js';

var TabBarWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(TabBarWrapper, _React$Component);
  var _super = _createSuper(TabBarWrapper);
  function TabBarWrapper(props) {
    var _this;
    _classCallCheck(this, TabBarWrapper);
    _this = _super.call(this, props);
    _this.registerEventListeners = function (element) {
      if (_this.innerElement) {
        _this.innerElement.removeEventListener("mousedown", _this.onMouseDown);
        _this.innerElement.removeEventListener("touchstart", _this.onMouseDown);
        _this.innerElement.removeEventListener("mouseup", _this.onMouseUp);
        _this.innerElement.removeEventListener("touchend", _this.onMouseUp);
        _this.innerElement.removeEventListener("touchmove", _this.onMouseMove);
        _this.innerElement.removeEventListener("mousemove", _this.onMouseMove);
        _this.innerElement.removeEventListener("mouseleave", _this.onMouseUp);
        _this.innerElement.removeEventListener("touchcancel", _this.onMouseUp);
      }
      if (!element) {
        return;
      }
      // remove Eventlisteners first because we only need one eventlistener...
      // "passive:false" parameter: we need this because of a browser error that occurs when calling `preventDefault`
      // in the function... so we tell the listener that there could be a preventDefault.
      element.addEventListener("mousedown", _this.onMouseDown, {
        passive: false
      });
      element.addEventListener("touchstart", _this.onMouseDown, {
        passive: false
      });
      element.addEventListener("mouseup", _this.onMouseUp, {
        passive: false
      });
      element.addEventListener("touchend", _this.onMouseUp, {
        passive: false
      });
      element.addEventListener("touchmove", _this.onMouseMove, {
        passive: false
      });
      element.addEventListener("mousemove", _this.onMouseMove, {
        passive: false
      });
      element.addEventListener("mouseleave", _this.onMouseUp);
      element.addEventListener("touchcancel", _this.onMouseUp);
    };
    _this.onMouseUp = function () {
      // known issue: on non-touch viewport, if you drag and release the mouse, the click on the link is fired.
      // this is not desired.
      // However, on touch devices (tested in Chrome), this does not occur, so when your release the mouse button on
      // drag, the link does not fire.
      // As we will use the scroll functionality mostly on touch devices, let's leave the issue by now.
      // Already tried something like this, but did not help:
      // if (this.state.isDragging){
      //     //event.preventDefault();
      // }
      _this.setState({
        isDragging: false
      });
    };
    _this.onMouseDown = function (event) {
      _this.setState(function (prevState) {
        return {
          mouseDownXPos: event.clientX || event.changedTouches[0].clientX,
          initialOffsetLeft: prevState.offsetLeft,
          isDragging: true
        };
      });
    };
    _this.onMouseMove = function (event) {
      if (_this.state.isDragging) {
        var currentMouseXPos = event.clientX || event.changedTouches[0].clientX;
        if (_this.getMaxScrollSpace()) {
          var offsetLeft = _this.state.initialOffsetLeft + currentMouseXPos - _this.state.mouseDownXPos;
          offsetLeft = Math.min(0, offsetLeft);
          offsetLeft = Math.max(offsetLeft, -_this.getMaxScrollSpace());
          _this.setState({
            offsetLeft: offsetLeft
          });
        }
      }
    };
    _this.getMaxScrollSpace = function () {
      if (_this.innerElement) {
        var innerWrapperWidth = _this.innerElement.getBoundingClientRect().width;
        var parentElementWidth = _this.innerElement.parentElement.getBoundingClientRect().width;
        return Math.max(innerWrapperWidth - parentElementWidth, 0);
      }
      return 0;
    };
    _this.onResize = function () {
      _this.setState({
        isDragging: false,
        mouseDownXPos: 0,
        offsetLeft: 0
      });
    };
    _this.onClickArrowLeft = function () {
      var offsetLeft = Math.min(_this.state.offsetLeft + 100, 0);
      _this.setState({
        offsetLeft: offsetLeft
      });
    };
    _this.onClickArrowRight = function () {
      var offsetLeft = Math.max(_this.state.offsetLeft - 100, -_this.getMaxScrollSpace());
      _this.setState({
        offsetLeft: offsetLeft
      });
    };
    _this.state = {
      isDragging: false,
      offsetLeft: 0,
      counter: 1
    };
    return _this;
  }
  _createClass(TabBarWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addResizeCallback(this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeResizeCallback(this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        // render twice to update indicator
        this.setState(function (p) {
          return {
            counter: p.counter + 1
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showArrowLeft = this.state.offsetLeft <= -4;
      var showArrowRight = this.state.offsetLeft >= 4 - this.getMaxScrollSpace();
      var tabsCentered = showArrowLeft || showArrowRight ? false : this.props.centeredLayout;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabBarPresentation, Object.assign({}, this.props, {
        onChange: function onChange(newName, e) {
          if (!_this2.state.isDragging) {
            _this2.props.onChange(newName, e);
          }
        },
        activeElement: this.activeElement,
        activeRef: function activeRef(r) {
          return _this2.activeElement = r;
        },
        innerRef: function innerRef(r) {
          _this2.innerElement = r;
          _this2.registerEventListeners(r);
        },
        offsetLeft: this.state.offsetLeft,
        showArrowLeft: showArrowLeft,
        showArrowRight: showArrowRight,
        value: this.props.value,
        onClickArrowLeft: this.onClickArrowLeft,
        onClickArrowRight: this.onClickArrowRight,
        centeredLayout: tabsCentered
      })));
    }
  }]);
  return TabBarWrapper;
}(React.Component);
TabBarWrapper.defaultProps = {
  onChange: function onChange() {
    /* empty */
  }
};

export { TabBarWrapper };
